export class SOAPRecurringPaymentRequest {
    speedFrameToken!: string;
    creditAccount!: string;
    amount!: number;
    email!: string;
    debitName!: string;
    debitZip!: string;
    recurring: boolean = false;
    paymentMethod : PaymentMethod = new PaymentMethod();
}

export class PaymentMethod{
    bpno!: string;
    paymentType! : string;
}